module.exports = __webpack_public_path__ + "e67ca4687ddf138791c6ecb783dc78e6.svg";